import React from 'react';
import { AppHeader, AppFooter } from '@/components'
import { Route, NavLink } from 'react-router-dom'
import CompanyNews from './CompanyNews';
import Industry from './Industry'
import Policy from './Policy'
let Swiper = window.Swiper
const $ = window.$;
class News extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      title: [
        {
          name: '公司动态',
          url: '/Introduction/CompanyNews',
          value: 0
        },
        {
          name: '热点聚焦',
          url: '/News/Industry',
          value: 1
        },
        {
          name: '青矩洞察',
          url: '/News/Policy',
          value: 2
        },
      ],
      navSwiper: '',
    }
  }
  componentDidMount() {
    const that = this
    this.setState({
      navSwiper: new Swiper('#tab-container', {
        speed: 500,
        autoHeight: true,
        on: {
          slideChangeTransitionStart: function () {
            const scrollTop = $(window).scrollTop();
            for (let index = 0; index < that.state.title.length; index++) {
              const item = that.state.title[index];
              if (index === this.activeIndex) {
                that.props.history.push(item.url)
                break;
              }
            }
            that.state.navSwiper.slideTo(this.activeIndex, 1000, false);
            const top1 = document.getElementsByClassName('top')[0].clientHeight;
            if (scrollTop >= top1) {
              window.scrollTo(0, top1);
            }
          }
        }
      })
    })
    // 初始化
    setTimeout(() => {
      this.handleRouterUrl()
    }, 0);
    that.stickFn()
  }
  stickFn() {
    const top1 = document.getElementsByClassName('top')[0];
    const top2 = document.getElementsByClassName('top')[1];
    const fixedHeight = top1.clientHeight + top2.clientHeight
    $(window).scroll(function () {
      var scroH = $(this).scrollTop();
      if (scroH > fixedHeight) {
        $(".navtop").css({ "position": "fixed", "top": 0, "display": "flex", "justifyContent": "spaceAround", "alignItems": "center", "Zindex": 2, "width": '100%', "background": '#fff' });
      } else if (scroH <= fixedHeight) {
        $(".navtop").css({ "position": "static" });
      }
    });
  }
  componentDidUpdate() {
    // 路由点击时
    this.handleRouterUrl()
  }
  handleRouterUrl() {
    for (let index = 0; index < this.state.title.length; index++) {
      const item = this.state.title[index];
      const pathname = this.props.location.pathname
      if (pathname === item.url) {
        // this.props.history.push(pathname)
        this.state.navSwiper.slideTo(index)
        break;
      }
    }
  }
  handleNavToggle(value) {
    this.state.navSwiper.slideTo(value)
  }
  render() {
    return (
      <div className="news">
        <Route component={AppHeader} />
        <div id="news-body">
          <nav className="top navtop">
            {
              this.state.title.map((item, index) =>
                <NavLink key={index} to={item.url} className="nav-title"
                  onClick={() => this.handleNavToggle(item.id)}>{item.name}</NavLink>
              )
            }
          </nav>
        </div>
        <section className="swiper-container" id="tab-container" >
          <div className="swiper-wrapper" >
            <article className="swiper-slide">
              <CompanyNews />
            </article>
            <article className="swiper-slide" >
              <Industry />
            </article>
            <article className="swiper-slide" >
              <Policy />
            </article>
          </div>
        </section>
        <Route component={AppFooter} />
      </div>
    )
  }
}
export default News
